import { Dialog, Transition } from '@headlessui/react'
import { AxiosError } from 'axios';
import Navbar from "../components/navbar";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/auth";
import { MessageContext } from '../contexts/message';
import { Popover } from "@headlessui/react";
import { TrashIcon, CreditCardIcon, BuildingLibraryIcon } from '@heroicons/react/24/outline'

import { getBillingData, setBillingData, singupFields, whoami } from '../services/api';
import {formatField} from './signup';

import { getLivelli, cancellaLivello, getPaymentInfo, setPaymentInfo } from "../services/api";

import { Elements, CardElement, IbanElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import TourUtente from '../components/tour_utente';
import Fetching from '../components/fetching';
import Swal from 'sweetalert2';



function ProfileBillingData() {

  const { token, profile, setProfile } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [billing, setBilling] = useState({});
  const [tipologia, setTipologia] = useState('azienda');
  const [loading, setLoading] = React.useState(false);


  const fetchBillingData = async () => {
    setFetching(true)
    getBillingData(token).then(response => {
      setBilling(response)
    }).finally(() => {setFetching(false)})
  };

  const refreshProfile = async () => {
    try {
      setLoading(true);
      const updatedProfile = await whoami(token);
  
      if (!updatedProfile) {
        throw new Error("Errore nel recupero del profilo");
      }
  
      setProfile(updatedProfile);
      await fetchBillingData();
    } catch (error) {
      console.error("Errore nel recupero del profilo o dei dipendenti attivi:", error);
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: 'Impossibile aggiornare il profilo e i dipendenti attivi.',
        confirmButtonText: 'OK',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBillingData()
  }, [])
  
  const fields = {
    "business_name": "Ragione Sociale",
    "name": "Nome",
    "surname": "Cognome",
    "city": "Città",
    "address": "Indirizzo",
    "province": "Provincia",
    "cap": "CAP",
    "cf": "Codice Fiscale",
    "piva": "Partita IVA",
    "phone_number": "Telefono",
    "pec": "PEC",
    "receiver_code": "Codice SDI",
  }

  if (fetching) {
    return <Fetching />
  }


  return (
    <>
      <div className="overflow-hidden bg-white shadow rounded-lg mt-5">
        <div className="px-4 py-6 sm:px-6 bg-gray-50 firstStepProfFatt justify-between flex">
          <h3 className="text-base font-semibold leading-7 text-gray-900">DATI FATTURAZIONE</h3>
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Modifica
            </button>
        </div>
        <div className="border-t border-gray-100">
          <dl className="divide-y divide-gray-100">
            {Object.keys(billing).map(field_name => {
              const label = fields[field_name];
              const value = billing[field_name];

              return label && <div key={field_name} className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-900">{label}</dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {value}
                </dd>
              </div>;
            })}
            
            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-900"></dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Modifica
                </button>
              </dd>
            </div>


            <Transition.Root show={open} as={Fragment}>
              <Dialog as="div" className="relative" style={{ zIndex: 200 }} onClose={() => {}}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                  <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enterTo="opacity-100 translate-y-0 sm:scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-6 pt-6 text-left shadow-xl transition-all my-20 xl:my-8 w-3/4">
                      <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 focus:outline-none"
                      >
                        <span className="sr-only">Chiudi</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button> 
                        <div>
                          <EditProfileForm open={open} data={billing} fields={fields} setData={setBilling} close={() => setOpen(false)} refresh={setBilling} refreshProfile={refreshProfile} />
                        </div>
                        <div className="mt-5 sm:mt-6">
                          
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
          </dl>
        </div>
      </div>
</>
  )
}

function EditProfileForm({ data, setData, fields, close, refreshProfile }) {
  const { token } = useContext(AuthContext)
  const dataRef = React.useRef({});
  const formRef = React.useRef(null);
  const [error, setError] = React.useState(null);
  const [fieldsSignup, setFieldsSignup] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [dataState, setDataState] = React.useState({});
  
  useEffect(() => {
    const getFields = async () => {
      setLoading(true);
      const fieldsData = await singupFields();
      setFieldsSignup(fieldsData);
      setLoading(false);
    };
    getFields();
  }, []); 

  useEffect(() => {
    const dataToSet = {...data, ...dataState};
    Object.keys(dataToSet).map(field_name => {
      const value = dataToSet[field_name]
      const el = dataRef.current[field_name];

      if(el) el.value = value
    })
  }, [fieldsSignup, dataState]); 

  const handleSubmit = (e) => {
    e.preventDefault();

    const missingFields = {};

    Object.entries(dataRef.current).forEach(([key, ref]) => {
      const value = ref?.value;
      const isRequired = fieldsSignup?.[key]?.required;

      if (isRequired && (!value || String(value).trim() === '')) {
        missingFields[key] = ['Campo obbligatorio'];
      }
    });

    const provinceValue = dataRef.current?.province?.value || '';
    const provinceRegex = /^[A-Z]{2}$/;
    if (provinceValue && !provinceRegex.test(provinceValue)) {
      missingFields['province'] = ['Inserire una sigla di provincia valida (es: RM)'];
    }

    if (Object.keys(missingFields).length > 0) {
      setError(missingFields);
      return;
    }

    setError(null);
    setLoading(true);

    Swal.fire({
      title: 'Salvataggio in corso...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const dataToSave = {
      ...data,
    };

    Object.entries(dataRef.current).forEach(([key, ref]) => {
      if (ref && 'value' in ref) {
        dataToSave[key] = ref.value;
      }
    });

    setDataState(dataToSave);

    setBillingData(token, dataToSave)
      .then(() => whoami(token))
      .then((updatedProfile) => {
        setData(updatedProfile);
        refreshProfile();
        close();

        Swal.fire({
          icon: 'success',
          title: 'Salvato',
          timer: 1500,
          showConfirmButton: false,
        });
      })
    .catch((error) => {
      console.error('Errore durante il salvataggio:', error);

      let errorMessage = 'Errore durante il salvataggio.';

      if (error.response && error.response.data?.errors) {
        const errorData = error.response.data.errors;
        const formattedMessages = [];

        Object.entries(errorData).forEach(([field, messages]) => {
          if (Array.isArray(messages)) {
            messages.forEach((msg) => {
              formattedMessages.push(`${field}: ${msg}`);
            });
          } else if (typeof messages === 'string') {
            formattedMessages.push(`${field}: ${messages}`);
          }
        });

        if (formattedMessages.length > 0) {
          errorMessage = formattedMessages.join(', \n'); 
        }
      }

      setError(errorMessage);

      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    })
    .finally(() => {
      setLoading(false);
    });
    return false;
  };

  const fieldLoaded = Object.keys(fields).length > 0
  if (loading || !fieldLoaded) {
    return <Fetching />
  }
  return (
    <form className="p-4 pb-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" ref={formRef}>
      {
        !loading && fieldLoaded && Object.keys(data).map((field_name, idx) => {
          const label = fields[field_name];
          const id = `${field_name}_${idx}`;
          const field = fieldsSignup[field_name];

          if (!field) return null;
          const field_formatted = formatField(field, field_name, id, dataRef, {}, () => {}, dataState[field_name])

          return <div key={id} style={{display: (field.hide ? 'none' : 'block') }}>
              <label htmlFor={id} className="block text-sm font-medium leading-6 text-gray-900 mt-2">
                {
                  field.label
                } {field.required && '*'}
              </label>
              <div className="mt-0">
                { field_formatted }
              </div>
              { 
                error && error[field_name] 
                && <div className="mt-2 text-sm text-red-700">
                  <ul role="list" className="list-disc space-y-1 pl-5">
                    {
                      error[field_name].map((e, idx) => (
                        <li key={idx}>{e}</li>
                      ))
                    }
                  </ul>
                </div>
              }
            </div>
        })
      }
      
      <div className="col-span-full flex justify-center gap-4">
        <button
          type="button"
          className="rounded bg-white px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 shadow-md"
          onClick={() => close()}
        >
          Annulla
        </button>
        <button
          type="submit"
          className="rounded bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-md hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={handleSubmit}
        >
          Salva le modifiche
        </button>
      </div>
    </form>
  );
}

export default function ProfileBilling () {
  const { profile } = useContext(AuthContext);
  const isProfileComplete = profile.has_complete_profile;

  return (
    <>
      <div className="min-h-full">
      {!isProfileComplete && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti nel form.
              
            </p>
          </div>
        </div>
      )}
        <main className="mt-10 pb-8">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap ">
              <div className="w-full px-4">
                <div className="w-full px-4 mb-5">
                  <ProfileBillingData />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  )
}


// TODO move to env

// const stripePromise = loadStripe('pk_test_51HKQnEJ5JenAfL5nRN0YiVuvUCR5BNX7kofRvQCNIGupiGaQ97G2DKGHEkJN9SPk6frDeAweYgGlmec7wM7RjbIq00ynck7MwQ');


// const setPaymentMethod = async (token, stripeToken) => {
//   await setPaymentInfo(token, stripeToken)
// }

// function Element ({refresh, stripeElement, title, elementType, tokenCreateData, sourceData}) {
//   const {token} = React.useContext(AuthContext);
//   const message = React.useContext(MessageContext);
//   const [loading, setLoading] = React.useState(false);

//   const elements = useElements();
//   const stripe = useStripe();
  

//   const handleSubmit = async (event) => {
//     // Block native form submission.
//     event.preventDefault();

//     if (!stripe || !elements) {
//       // Stripe.js has not loaded yet. Make sure to disable
//       // form submission until Stripe.js has loaded.
//       return;
//     }
//     // @ts-ignore
//     const element = elements.getElement(elementType);

//     if (element == null) {
//       return;
//     }
//     setLoading(true);
    
//     let { error, token: stripeToken } = await stripe.createToken(element, tokenCreateData);
//     if (elementType == 'iban') {
//       let data;

//       if(typeof sourceData === 'function') 
//         data = sourceData();
//       else
//         data = sourceData
      
//       const response = await stripe.createSource(element, data)
//       error = response.error;
//       // todo da migliorare perché andrà deprecato
//       // @ts-ignore
//       stripeToken = response.source;
//     }

//     if (error) {
//       console.log('[error]', error);
//       message.message.error('Errore, riprovare più tardi')
//     } else {
//       try {
//         await setPaymentMethod(token, stripeToken.id)
//         message.message.info('Aggiornato con successo')
//         refresh()
//       } catch (e) {
//         console.log(e)
//         const error = e;
//         const data = error.response?.data;
//         if(data?.error)
//           message.message.error(data.error);
//       }
//     }
//     setLoading(false);
//   };
//   // React.useEffect(() => {setLoading(false);}, [])
//   return (
//     <>  
//       {loading && <div
//       className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
//     >
//       <div role="status">
//         <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
//           <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
//         </svg>
//         <span className="sr-only">Loading...</span>
//       </div>
//       <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
//     </div>}
//       <div style={{display: loading ? 'none': 'block'}} className="p-3">     
//         <h1 className="p-3">{title}</h1>
//         <form className="p-3" id="form" onSubmit={handleSubmit}>
//             {stripeElement}
//             {elementType === 'iban' && (
//               <p className="text-justify mx-2 sm:mx-10 mt-10">
//                 Fornendo il tuo IBAN e confermando questo pagamento, autorizzi Consultala SRL e Stripe, il nostro fornitore di servizi di pagamento, ad inviare istruzioni alla tua banca per addebitare il tuo conto in conformità con tali istruzioni. Hai diritto a un rimborso dalla tua banca secondo i termini e le condizioni del tuo accordo con essa. Un rimborso deve essere richiesto entro otto settimane a partire dalla data in cui è stato addebitato sul tuo account.
//               </p>
//             )}
//           <div className="grid justify-items-center mt-4 text-sm leading-6 text-gray-700">
//             <button
//               type="submit"
//               className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 mt-5"
//             >Aggiorna</button>
//           </div>
//         </form>
//       </div> 
//     </>
//   );
// }


// const LivelliAttivi = () => {
//   const [currentLevels, setCurrentLevels] = React.useState([]);
//   const { token } = useContext(AuthContext);


//   React.useEffect(() => {
//     getLivelli(token).then(data => {
//         setCurrentLevels(data.user_levels);
//     })
//   }, []);


// const handleDeleteLevel = async (level) => {
//   const ok = confirm('Confermi la cancellazione del piano?');

//   if(!ok)
//       return;

//   try {
//       await cancellaLivello(token, level.pk);
//   } catch (error) {
//       alert('qualcosa è andato storto, riprova più tardi');
//       console.error(error)
//   }

// };
  
//   return <div className="overflow-hidden bg-white shadow sm:rounded-lg mt-5 rounded-lg">
//         <div className="px-4 py-6 sm:px-6 bg-gray-50">
//           <h3 className="text-base font-semibold leading-7 text-gray-900 secondStepProfFatt">SOTTOSCRIZIONI ATTIVE</h3>
//         </div>
        
//         {currentLevels.length < 1 && (
//           <p className="flex items-center px-6 py-5">Non sono presenti sottoscrizioni attive</p>
//         )}
        
//         {currentLevels.map(level => {
//           return <div key={level.pk} className="border-t border-gray-100">
//           <dl className="divide-y divide-gray-100">
//             <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//               <dt className="text-sm font-medium text-gray-900">Piano</dt>
//               <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//                 {level.name}
//               </dd>
//             </div>
//             <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//               <dt className="text-sm font-medium text-gray-900">Stato</dt>
//               <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 flex justify-between">
//                 {level.status?.toUpperCase()}
//                 {/* #TODO: da migliorare condizione su button elimina */}
//                 { level.status != 'Cancellato alla fine del periodo' && level.status !== 'In prova' ? (
//                 <button onClick={() => handleDeleteLevel(level)} className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
//                     Elimina
//                     <TrashIcon className="h-5 w-5" />
//                 </button>
//                  ) : null}
//               </dd>
//             </div>
//             {
//               level.plans?.map(plan => <div key={plan.pk} className="border-t border-gray-100"> 
//               <dl className="divide-y divide-gray-100">
//                 <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                   <dt className="text-sm font-medium text-gray-900">Codice Sottoscrizione</dt>
//                   <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//                     {plan.subscription}
//                   </dd>
//                 </div>
//                 <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                   <dt className="text-sm font-medium text-gray-900">Prezzo</dt>
//                   <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//                     € {plan.human_price}
//                   </dd>
//                 </div>
//                 <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                   <dt className="text-sm font-medium text-gray-900">Durata Piano</dt>
//                   <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//                     {plan.duration_months} {plan.duration_months === 1 ? "mese" : "mesi"}
//                   </dd>
//                 </div>
//                 <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                   <dt className="text-sm font-medium text-gray-900">
//                     {level.status === 'Cancellato alla fine del periodo' ? 'Termine del periodo' : 'Prossimo Rinnovo'}
//                   </dt>
//                   <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//                     {plan.current_period_end}
//                   </dd>
//                 </div>
//               </dl>
//             </div>
//             )}
//           </dl>
//         </div>
//         })
//       }
//       </div>
// }



// function EditProfileForm({ data, setData, fields, close }) {
//   const { token } = useContext(AuthContext)
//   const dataRef = React.useRef({});
//   const formRef = React.useRef(null);
//   const [error, setError] = React.useState(null);
//   const [fieldsSignup, setFieldsSignup] = React.useState({});
//   const [loading, setLoading] = React.useState(false);
  
//   useEffect(() => {
//     const getFields = async () => {
//       setLoading(true);
//       const fieldsData = await singupFields();
//       setFieldsSignup(fieldsData);
//       setLoading(false);
//     };
//     getFields();
//   }, []); 

//   useEffect(() => {
//     Object.keys(data).map(field_name => {
//       const value = data[field_name]
//       const el = dataRef.current[field_name];
//       if(el) el.value = value
//     })
//   }, [fieldsSignup]); 

//   const handleSubmit = (e) => {
//     if(formRef.current?.checkValidity() === false) {
//       return false
//     }
//     e.preventDefault()

//     setError(null);
//     setLoading(true);
//     const data = Object.fromEntries(
//       Object.keys(dataRef.current).map(key => {
//         return [key, dataRef.current[key]?.value]
//       })
//     );

//     setBillingData(token, data)
//       .then(response => {
//         setData(data)
//         close()

//         return false
//       })
//       .catch(e => {
//         const error = e;

//         if(error.response?.data?.errors) {
//           const errors = error.response.data.errors;
//           setError(errors);
//           return false;
//         }

//         throw new Error(`Error in 'edit': ${error.message}`);
//       });

//       setLoading(false);
//     return false;
//   };

//   const fieldLoaded = Object.keys(fields).length > 0
//   if (loading || !fieldLoaded) {
//     return <div
//       className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
//     >
//       <div role="status">
//         <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
//           <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
//         </svg>
//         <span className="sr-only">Loading...</span>
//       </div>
//       <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
//     </div>
//   }
  
//   return (
//     <form className="p-4" ref={formRef}>
//       {
//         !loading && fieldLoaded && Object.keys(data).map((field_name, idx) => {
//           const label = fields[field_name];
//           const id = `${field_name}_${idx}`;
//           const field = fieldsSignup[field_name];

//           if(!field) {
//             return
//           }
//           const field_formatted = formatField(field, field_name, id, dataRef)
//           return <div key={id} style={{display: (field.hide ? 'none' : 'block') }}>
//               <label htmlFor={id} className="block text-sm font-medium leading-6 text-gray-900">
//                 {
//                   field.label
//                 } {field.required && '*'}
//                 { 
//                   error && error[field_name] 
//                   && <div className="mt-2 text-sm text-red-700">
//                     <ul role="list" className="list-disc space-y-1 pl-5">
//                       {
//                         error[field_name].map((e, idx) => (
//                           <li key={idx}>{e}</li>
//                         ))
//                       }
//                     </ul>
//                   </div>
//                 }
//               </label>
//               <div className="mt-2">
//                 { field_formatted }
//               </div>
//             </div>
//         })
//       }
      

      
//       <span className="isolate inline-flex rounded-md shadow-sm w-full justify-between">
//         <button
//           type="button"
//           className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
//           onClick={() => close()}
//         >
//           Annulla
//         </button>
//         <button
//           type="submit"
//           className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//           onClick={handleSubmit}
//         >
//           Salva le modifiche
//         </button>
//       </span>
//     </form>
//   );
// }


// function ProfileBillingData() {

//   const { token } = useContext(AuthContext)
//   const [open, setOpen] = useState(false)
//   const [fetching, setFetching] = useState(true)
//   const [billing, setBilling] = useState({})

//   const fetchBillingData = async () => {
//     setFetching(true)
//     getBillingData(token).then(response => {
//       setBilling(response)
//     }).finally(() => {setFetching(false)})
//   }

//   useEffect(() => {
//     fetchBillingData()
//   }, [])

//   const fields = {
//     "business_name": "Ragione Sociale",
//     "name": "Nome",
//     "surname": "Cognome",
//     "city": "Città",
//     "address": "Indirizzo",
//     "province": "Provincia",
//     "cap": "CAP",
//     "cf": "Codice Fiscale",
//     "piva": "Partita IVA",
//     "phone_number": "Telefono",
//     "pec": "PEC",
//     "receiver_code": "Codice SDI",
//   }

//   if (fetching) {
//     return <div
//       className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
//     >
//       <div role="status">
//         <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
//           <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
//         </svg>
//         <span className="sr-only">Loading...</span>
//       </div>
//       <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
//     </div>
//   }


//   return (
//     <>
//       <div className="overflow-hidden bg-white shadow rounded-lg mt-5">
//         <div className="px-4 py-6 sm:px-6 bg-gray-50 firstStepProfFatt">
//           <h3 className="text-base font-semibold leading-7 text-gray-900">DATI FATTURAZIONE</h3>
//         </div>
//         <div className="border-t border-gray-100">
//           <dl className="divide-y divide-gray-100">
//             {Object.keys(billing).map(field_name => {
//               const label = fields[field_name];
//               const value = billing[field_name];

//               return label && <div key={field_name} className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-900">{label}</dt>
//                 <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//                   {value}
//                 </dd>
//               </div>;
//             })}
            
//             <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//               <dt className="text-sm font-medium text-gray-900"></dt>
//               <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//                 <button
//                   type="button"
//                   onClick={() => setOpen(true)}
//                   className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//                 >
//                   Modifica
//                 </button>
//               </dd>
//             </div>


//             <Transition.Root show={open} as={Fragment}>
//               <Dialog as="div" className="relative z-10" onClose={setOpen}>
//                 <Transition.Child
//                   as={Fragment}
//                   enter="ease-out duration-300"
//                   enterFrom="opacity-0"
//                   enterTo="opacity-100"
//                   leave="ease-in duration-200"
//                   leaveFrom="opacity-100"
//                   leaveTo="opacity-0"
//                 >
//                   <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
//                 </Transition.Child>

//                 <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
//                   <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
//                     <Transition.Child
//                       as={Fragment}
//                       enter="ease-out duration-300"
//                       enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
//                       enterTo="opacity-100 translate-y-0 sm:scale-100"
//                       leave="ease-in duration-200"
//                       leaveFrom="opacity-100 translate-y-0 sm:scale-100"
//                       leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
//                     >
//                       <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
//                         <div>
//                           <EditProfileForm open={open} data={billing} fields={fields} setData={setBilling} close={() => setOpen(false)} refresh={setBilling} />
//                         </div>
//                         <div className="mt-5 sm:mt-6">
                          
//                         </div>
//                       </Dialog.Panel>
//                     </Transition.Child>
//                   </div>
//                 </div>
//               </Dialog>
//             </Transition.Root>
//           </dl>
//         </div>
//       </div>
// </>
//   )
// }

// function ButtonIcon(props) {
//   const { active, onClick, children } = props;
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className={`rounded bg-indigo-${active ? '500' : '600'} px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
//     >
//       {children}
//     </button>
//   );
// }


// function IbanElementWithName(props) {
//   const { profile } = React.useContext(AuthContext);
//   const nameRef = React.useRef(null);

//   const getSourceData = () => ({
//     type: 'sepa_debit',
//     currency: 'eur',
//     owner: {
//       name: nameRef.current?.value,
//       email: profile.profile.email_auth,
//     },
//     mandate: {
//       notification_method: 'email'
//     }
//   });

//   return (
//     <>
//       <div className="p-3">
//         Intestatario Conto Corrente:
//         <input
//           type='text'
//           ref={nameRef}
//           className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
//         />
//       </div>
//       <Element sourceData={getSourceData} tokenCreateData={{ currency: 'eur' }} refresh={props.refresh} elementType={'iban'} stripeElement={<IbanElement options={{ supportedCountries: ['SEPA'] }} />} title='Iban' />
//     </>
//   );
// }


// function EditPaymentMethod(props) {
//   const [type, setType] = React.useState('card');

//   const availableTypes = {
//     'card': React.createElement(Element, { refresh: props.refresh, elementType: 'card', stripeElement: React.createElement(CardElement, null), title: 'Carta di pagamento' }),
//     'bank': React.createElement(IbanElementWithName, Object.assign({}, props))
//   };
  
//   return <>
//       <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//         <dt className="text-sm font-medium text-gray-900">Seleziona il metodo di pagamento</dt>
//         <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
//           <div className="flex flex-col mt-4 text-sm leading-6 text-gray-700 sm:flex-row sm:items-center sm:justify-center">
//             <div className="grid grid-cols-2 gap-4 w-full">
//               <div className="col-span-1 flex flex-col items-center justify-center text-center sm:text-left">
//                 <ButtonIcon active={type == 'card'} onClick={() => {setType('card')}}>
//                   <CreditCardIcon className="h-5 w-5" />
//                 </ButtonIcon>
//                 <h5 className="mt-2 sm:mt-0">Carta di credito/debito</h5>
//               </div>
//               <div className="col-span-1 flex flex-col items-center justify-center text-center sm:text-left">
//                 <ButtonIcon active={type == 'bank'} onClick={() => {setType('bank')}}>
//                   <BuildingLibraryIcon className="h-5 w-5" />
//                 </ButtonIcon>
//                 <h5 className="mt-2 sm:mt-0">Addebito in C/C</h5>
//               </div>
//             </div>
//           </div>
//         </dd>
//       </div>
    
        
//     <Elements stripe={stripePromise}>
//       {availableTypes[type]}
//     </Elements>
//   </>
// }

// function PaymentMethodData() {
//   const { token } = useContext(AuthContext);
//   const [paymentInfo, setPaymentMethod] = React.useState(null);
//   const refresh = () => {
//     getPaymentInfo(token).then(response => {setPaymentMethod(response.source)})
//   }
//   React.useEffect(() => {
//     refresh()
//   }, [])

//   return <>

//   <div className="overflow-hidden bg-white shadow sm:rounded-lg mt-5 rounded-lg thirdStepProfFatt">
//     <div className=" p-6 bg-gray-50">
//       <h3 className="text-base font-semibold leading-7 text-gray-900 pb-2">METODO DI PAGAMENTO</h3>
//     </div>
//     <div className="overflow-hidden bg-white shadow rounded-bl-lg rounded-br-lg">
//       {paymentInfo ? (
//         <>
//           {paymentInfo.type === 'card' && (
//             <p className="flex items-center px-6 pt-6"><CreditCardIcon className="h-5 w-5 mr-3" />{paymentInfo.info}</p>
//           )}
//           {paymentInfo.type === 'bank' && (
//             <p className="flex items-center px-6 pt-6"><BuildingLibraryIcon className="h-5 w-5 mr-3" />
//             {paymentInfo.info}</p>
//           )}
//           <p className="flex items-center px-6 py-5">{paymentInfo.expire}</p>
//         </>
//       ) : <p className="flex items-center px-6 py-5">Non hai un metodo di pagamento</p>}
//     <div className="py-5 bg-gray-50">
//       <h3 className="text-base font-semibold leading-7 text-gray-900 px-6">AGGIORNA METODO DI PAGAMENTO</h3>
//     </div>
//       <EditPaymentMethod refresh={refresh} />
//     </div>
//   </div>
//   </>
// }


// export default function ProfileBilling () {
//   const { profile } = useContext(AuthContext)
//   return (
//     <>
//       <div className="min-h-full">
      
//       <main className="mt-10 pb-8">
//           <div className="container mx-auto px-4">
//             <div className="flex flex-wrap ">
//               <div className="w-full px-4">
//                 <div className="w-full px-4 mb-5">
//                   <ProfileBillingData />
//                 </div>
//                 <div className="flex flex-wrap">
//                   <div className="w-full px-4 mb-5">
//                     <LivelliAttivi />
//                   </div>
//                 </div>
//               <div className="flex flex-wrap">
//                 <div className="w-full px-4 mb-5">
//                   <PaymentMethodData />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//       </div>
//   </>
//   )
// }